// import FooterSignedin from "../components/Footer.signedin"
import { useEffect, useState, createContext } from "react"
import Description from "../components/Accomodation/Description"
import MapSection from "../components/Accomodation/MapSection"
import Rating from "../components/Accomodation/Rating"
import ReviewSection from "../components/Accomodation/ReviewSection"
import ServicesSection from "../components/Accomodation/ServicesSection"
import Contact from "../components/contact/Contact"
import Gallery from "../components/gallery/Gallery"
import NavBar from "../components/NavBar"
import PageSummary from "../components/PageSummary"
import { Accomodation } from "../others/accomodation.interfaces"
import { pageSummaryInfo } from "../others/common.interfaces"
import SampleData from '../sampledata.json'
import Footer from '../components/footerUnsignedIn/Footer'
import { Dialog, Step, StepButton, Stepper } from "@mui/material"
import Form from "../components/form/Form"

export interface BookingContext {
    book: boolean;
    setBook: React.Dispatch<React.SetStateAction<boolean>> | null;
}

export const bookingContext = createContext<BookingContext>({ book: false, setBook: null });

const AccomodationPage = (): JSX.Element => {
    const [activeStep, setActiveStep] = useState<number>(0)
    const [book, setBook] = useState<boolean>(true);
    const [summary, setSummary] = useState<pageSummaryInfo>({
        bgImage: '',
        title: '',
        description: '',
        socialMedia: null
    })
    const [data, setData] = useState<Accomodation | null>(null)
    useEffect(() => {
        setData({
            ...(SampleData.accomodations[0])
        })
        setSummary({
            bgImage: 'https://picsum.photos/1000',
            title: SampleData.accomodations[0].name,
            description: "",
            socialMedia: SampleData.socialmedia
        })
    }, [])
    return (
        <bookingContext.Provider value={{ book, setBook }}>
            <main className="AccomodationPage ">
                <NavBar />
                <PageSummary
                    {...summary}
                />
                <section className="px-4 py-7 midmaxw flex flex-col 2xl:flex-row gap-9 justify-between">
                    <div className="TextContent flex flex-row flex-wrap 2xl:flex-col gap-9 min-w-[260px]">
                        {
                            !data ?
                                <></>
                                :
                                <>
                                    <Description text={data.description} />
                                    <Rating {...{ ...data.rating, institutionType: data.institutionType ?? 'hotel' }} />
                                    <ReviewSection reviews={data.reviews} />
                                </>
                        }
                    </div>
                    <div className="flex flex-col gap-7 w-full max-w-[1000px] pb-12">
                        <MapSection />
                        <ServicesSection
                            categories={data?.categories}
                            services={data?.services || []}
                            accomodationName={data?.name ?? ''}
                        />
                        <Gallery />
                    </div>
                    <Contact contacts={[]} skeleton />
                </section>
            </main>

            <Footer />
            <Dialog
                open={book}
                onClose={() => setBook(false)}
                maxWidth={false}
            >
                <Stepper activeStep={activeStep} sx={{ maxWidth: "600px", margin: "auto", paddingTop: "40px" }}>
                    <Step>
                        <StepButton>Booking Details</StepButton>
                    </Step>
                    <Step>
                        <StepButton>Additional info</StepButton>
                    </Step>
                    <Step>
                        <StepButton>Required info</StepButton>
                    </Step>
                </Stepper>
                {
                    activeStep === 0 ?
                        <>
                            <div className="min-h-[80vh] w-[70vw] max-w-[900px] flex flex-col items-center p-8 rounded-2xl">
                                <h1 className="mb-10">Booking details</h1>
                                <Form
                                    fields={
                                        [
                                            {
                                                name: 'roomtype',
                                                props: {
                                                    options: [
                                                        { label: "conference", id: 1 },
                                                        { label: "bedrooom", id: 2 },
                                                        { label: "small meeting", id: 3 },
                                                    ],
                                                    inputPlaceholder: 'What type of room are you going to need?',
                                                    multiple: true
                                                },
                                                type: 'combobox',
                                            },
                                            {
                                                name: 'rooomnumber',
                                                type: 'textfield',
                                                props: {
                                                    type: 'number',
                                                    inputPlaceholder: 'How many of the rooms do you want to book?',
                                                },
                                                info: 'Leave it if your do not have the answer yet'
                                            },
                                            {
                                                name: 'meals',
                                                type: 'checkbox',
                                                showTitle: true,
                                                info: 'If yes , charges may increase',
                                                props: {
                                                    inputPlaceholder: 'Are you going to be taking meals with us?',
                                                    options: [
                                                        {
                                                            id: 1,
                                                            value: "Yes please!"
                                                        },
                                                        {
                                                            id: 2,
                                                            value: "No, we won't"
                                                        },
                                                    ]
                                                },
                                            },

                                        ]
                                    }
                                    showNext
                                    showBack
                                    onNext={() => setActiveStep(1)}
                                    />
                            </div>
                        </> :
                        <> <p>More data</p></>
                }
            </Dialog>
        </bookingContext.Provider>
    )
}

export default AccomodationPage